import { render, staticRenderFns } from "./detalleProducto.vue?vue&type=template&id=828e2dd0"
import script from "./detalleProducto.vue?vue&type=script&lang=js"
export * from "./detalleProducto.vue?vue&type=script&lang=js"
import style0 from "./detalleProducto.vue?vue&type=style&index=0&id=828e2dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports